import CustomPagination from "Component/common/CustomPagination";
import TableLayout from "Component/common/TableLayout";
import TableProfile from "Component/common/TableLayout/TableProfile";
import TableStatusOptionsAction from "Component/common/TableStatusOptionsAction";
import { Container } from "react-bootstrap";
import { MANAGE_USER } from "services/ApiCalls";
import { userStatusOptionArr } from "utilities/const";
import { removeUnderScore } from "utilities/utilities";

import TableActions from "Component/common/TableActions";
import usePermissions from "hooks/usePermissions";
import { PERMISSION_KEYS } from "utilities/permissionConst";

const Pendingtable = ({
  data,
  total,
  body,
  setBody,
  paginationHandler,
  loader,
  statusChangeHandler,
}) => {
  const permission = usePermissions({
    permissionKey: PERMISSION_KEYS.PENDING_USERS,
  });
  const col = [
    {
      head: "Picture",
      accessor: "email",
      component: (item) => <TableProfile image={item?.profileImage} />,
    },
    {
      head: "Name",
      accessor: "name",
    },
    {
      head: "Username",
      accessor: "",
      component: (item) => <>{item?.userName}</>,
    },
    {
      head: "Phone",
      accessor: "mobileNumber",

      component: (item) => <>{item?.countryCode + item?.mobileNumber || "-"}</>,
    },
    {
      head: "Email",
      accessor: "email",
    },
    {
      head: "User Type",
      accessor: "accountType",
      component: (item) => <>{removeUnderScore(item?.accountType)}</>,
    },
  ];

  if (permission.isAdd) {
    col.push({
      head: "Status",
      accessor: "accountType",
      component: (item, index) => (
        <TableStatusOptionsAction
          onChange={(userStatus, reason) => {
            statusChangeHandler(
              () =>
                MANAGE_USER(
                  reason
                    ? { ...reason, _id: item?._id, userStatus }
                    : { _id: item?._id, userStatus },
                ),
              index,
              "userStatus",
              userStatus,
              true,
            );
          }}
          statusOptionArr={userStatusOptionArr}
          value={item?.userStatus}
          showRejectModel={true}
        />
      ),
    });
  }

  if (permission?.isView) {
    col.push({
      head: "Action",
      accessor: "",
      component: (item) => (
        <TableActions
          permissionKey={PERMISSION_KEYS.PENDING_USERS}
          viewLink={`/view-user/${item._id}`}
        />
      ),
    });
  }
  return (
    <section className="Diagnosis_table com_table ">
      <Container>
        <TableLayout data={data} column={col} loader={loader} body={body} />
        <div className="pagination_list d-flex align-items-center gap-3 justify-content-end py-3">
          <CustomPagination
            total={total}
            body={body}
            setBody={setBody}
            pageChangeHandler={paginationHandler}
          />
        </div>
      </Container>
    </section>
  );
};

export default Pendingtable;
